// src/nakathData.js
const nakathData = [
    {
      time: "2026-04-13T09:00:00",
      si: {
        title: "පරණ අවුරුද්ද සඳහා ස්නානය",
        description: "අප්‍රේල් මස 13 වැනි ඉරිදා දින දිවුල්පත් යුෂ මිශ්‍ර නානු ගා ස්නානය කොට ඉෂ්ට දේවතා අනුස්මරණයෙහි යෙදී වාසය මැනවි."
      },
      en: {
        title: "Ritual Bath for the Old Year",
        description: "April 13. Before the old year ends, people take a herbal bath using juice extracted from Divul (wood apple) leaves."
      }
    },
    {
      time: "2026-04-14T09:32:00",
      si: {
        title: "අලුත් අවුරුදු උදාව",
        description: "අප්‍රේල් මස 14 වැනි අඟහරුවාදා දින පූර්වභාග 09.32 ට සිංහල අලුත් අවුරුද්ද උදාවෙයි."
      },
      en: {
        title: "Dawn of the New Year",
        description: "April 14 at 3:21 AM. This marks the official transition from the old year to the new. "
      }
    },
    {
      time: "2026-04-14T03:08:00",
      si: {
        title: "පුණ්‍ය කාලය",
        description: "අප්‍රේල් මස 14 වැනි අගහරුවාදා පූර්වභාග 03.08 සිට එදිනම අපර භාග 03.56 දක්වා සියලු වැඩ අත්හැර ආගමික වතාවත්වල යෙදීම."
      },
      en: {
        title: "Punya Kalaya (Neutral Period)",
        description: "From April 14 at 03:08 AM to 03:56 AM. During this period, all work is paused, and people engage in religious activities such as temple visits and prayers."
      }
    },
    {
      time: "2026-04-14T10:51:00",
      si: {
        title: "ආහාර පිසීම",
        description: "අප්‍රේල් මස 14 වැනි අගහරුවාදා උදේ 10.51 ට රක්ත වර්ණ වස්ත්‍රාභරණයෙන් සැරසී දකුණු දිශාව බලා ළිප් බැඳ ගිනි මොළවා කිරිබතක්ද කැවිලි වර්ගයක්ද දී කිරි සහ විලඳ ද පිළියෙල කර ගැනීම මැනවි."
      },
      en: {
        title: "Preparation of the First Meal",
        description: "April 14 at 10:51 AM. Wearing red-colored attire and facing the south, people light the hearth, prepare kiribath (milk rice), sweetmeats, and other traditional food, and boil fresh milk to symbolize prosperity."
      }
    },
    {
      time: "2026-04-14T12:06:00",
      si: {
        title: "වැඩ ඇල්ලීම, ගනුදෙනු, ආහාර අනුභවය",
        description: "අප්‍රේල් මස 14 වැනි අඟහරුවාදා අපර භාග 12.06 ට රක්ත වර්ණ වස්ත්‍රාභරණයෙන් සැරසී දකුණු දිශාව බලා සියලු වැඩ අල්ලා ගනුදෙනු කොට ආහාර අනුභව කිරීම මැනවි"
      },
      en: {
        title: "Starting Work, Transactions, and First Meal",
        description: "April 14 at 12:06 PM. Wearing red-colored clothing while facing south, people resume work, engage in financial transactions, and share the first meal of the year, ensuring prosperity and good fortune."
      }
    },
    {
      time: "2026-04-15T06:55:00",
      si: {
        title: "හිසතෙල් ගෑම",
        description: "අප්‍රේල් මස 15 වැනි බදාදා උදේ 06.55 ට පච්ච හෙවත් කොල පැහැති වස්ත්‍රාභරණයෙන් සැරසී නැගෙනහිර දිශාව බලා හිසට කොහොඹ පත් ද පයට කොළොන් පත් ද තබා කොහොඹ පත් යුෂ මිශ්‍ර නානු හා තෙල් ගා ස්නානය කිරීම මැනවි."
      },
      en: {
        title: "Anointing of Oil",
        description: "April 16 at 6:55 AM. Dressed in green-colored attire, people face north and anoint their heads with herbal oil infused with Kohomba (neem) leaves while placing Haldu (Kolon) leaves under their feet."
      }
    },
    {
      time: "2026-04-20T06:27:00",
      si: {
        title: "රැකීරක්ෂා සඳහා පිටත්ව යෑම",
        description: "අප්‍රේල් මස 20 වැනි සඳුදා පූර්ව භාග 06.27 ට ශ්වේත වර්ණ වස්ත්‍රාභරණයෙන් සැරසී කිරිබතක් හා එළකිරි මිශ්‍ර කැවිලිද අනුභව කර දකුණු දිශාව බලා පිටත්ව යෑම මැනවි."
      },
      en: {
        title: "Stepping Out for Work",
        description: "April 17 at 9:03 AM. Dressed in white-colored clothing, people eat kiribath and traditional sweets before stepping outside, facing south."
      }
    },
    {
      time: "2026-04-19T00:00:00",
      si: {
        title: "නව සඳ බැලීම",
        description: "අප්‍රේල් 19 (අභිනව සූර්ය වර්ෂය) දා නව සඳ බැලීම මැනවි."
      },
      en: {
        title: "Observing the New Moon",
        description: "April 19 (Solar New Year). Significance: The new moon is observed as an important transition."
      }
    }
  ];
  
  export default nakathData;
